import React, { lazy } from "react";

const LazyCreatePayment = lazy(() => import("./CreatePayment"));

const CreatePayment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCreatePayment {...props} />;

export default CreatePayment;
